import { lazy, ReactElement } from 'react';

const Dashboard = lazy(() => import('../pages/Dashboard'));
const AddExpense = lazy(() => import('../pages/AddExpense'));
const Insights = lazy(() => import('../pages/Insights'));
const Challenges = lazy(() => import('../pages/Challenges'));
const Settings = lazy(() => import('../pages/Settings'));
const AuthDemo = lazy(() => import('../pages/AuthDemo'));
const NotFound = lazy(() => import('../pages/NotFound404'));

interface Route {
  path: string;
  element: ReactElement;
}

const routes: Route[] = [
  { path: '/', element: <Dashboard /> },
  { path: '/add', element: <AddExpense /> },
  { path: '/insights', element: <Insights /> },
  { path: '/challenges', element: <Challenges /> },
  { path: '/settings', element: <Settings /> },
  { path: '/auth-demo', element: <AuthDemo /> },
  // universal 404 fallback
  { path: '*', element: <NotFound /> },
];

export default routes;
